<template>
  <div class="login-container">
    <div class="login-box">
      <h1 class="title">登录</h1>
      <div class="form-item">
        <input 
          v-model="username" 
          type="text" 
          class="input" 
          placeholder="请输入账号"
          @keyup.enter="handleLogin"
        />
      </div>
      <div class="form-item">
        <input 
          v-model="password" 
          type="password" 
          class="input" 
          placeholder="请输入密码"
          @keyup.enter="handleLogin"
        />
      </div>
      <div class="form-item captcha-container">
        <input 
          v-model="captcha" 
          type="text" 
          class="input captcha-input" 
          placeholder="请输入验证码"
          @keyup.enter="handleLogin"
        />
        <img 
          :src="captchaUrl" 
          class="captcha-img" 
          @click="refreshCaptcha" 
          alt="验证码"
        />
      </div>
      <button 
        class="btn" 
        :disabled="loading" 
        @click="handleLogin"
      >
        {{ loading ? '登录中...' : '登 录' }}
      </button>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'LoginPage',
  data() {
    return {
      username: '',
      password: '',
      captcha: '',
      captchaId: '',
      captchaUrl: '',
      loading: false
    }
  },
  created() {
    this.refreshCaptcha()
  },
  methods: {
    async refreshCaptcha() {
      try {
        const response = await request({
          url: '/api/v1/captcha',
          method: 'get'
        })
    
        if (response.success) {
          this.captchaId = response.data.captchaId
          this.captchaUrl = response.data.captcha
        } else {
          throw new Error(response.msg || '获取验证码失败')
        }
      } catch (error) {
        console.error('获取验证码失败:', error)
        alert(error.message || '获取验证码失败，请刷新页面重试')
      }
    },
    async handleLogin() {
      if (!this.username || !this.password || !this.captcha) {
        alert('请输入账号、密码和验证码')
        return
      }
      
      this.loading = true
      try {
        const response = await request({
          url: '/api/v1/accounts/login',
          method: 'post',
          data: {
            username: this.username,
            password: this.password,
            captcha: this.captcha,
            captchaId: this.captchaId
          }
        })

        if (response.success) {
          // 保存登录信息
          localStorage.setItem('token', response.data.token || 'admin-token')
          localStorage.setItem('userRole', 'admin')
          localStorage.setItem('adminEmail', this.username)
          localStorage.setItem('loginTime', new Date().toLocaleString('zh-CN'))
          
          // 管理员登录成功，跳转到管理后台
          this.$router.push('/admin')
        } else {
          throw new Error(response.msg || '登录失败')
        }
      } catch (error) {
        alert(error.message || '登录失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f8fa;
}

.login-box {
  background: #fff;
  padding: 32px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  width: 400px;
}

.title {
  color: #2176c7;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 32px;
}

.form-item {
  margin-bottom: 16px;
}

.input {
  width: 100%;
  height: 40px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 12px;
  font-size: 16px;
  box-sizing: border-box;
}

.input:focus {
  border-color: #2176c7;
  outline: none;
}

.captcha-container {
  display: flex;
  gap: 12px;
}

.captcha-input {
  flex: 1;
}

.captcha-img {
  height: 40px;
  border-radius: 4px;
  cursor: pointer;
}

.btn {
  width: 100%;
  height: 40px;
  background: #2176c7;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn:hover:not(:disabled) {
  background: #185a9d;
}

.btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}
</style> 